module.exports = __webpack_public_path__ + "img/icon-nav-add-icon.0030e154.svg";